import React from "react";
import { Link } from "gatsby";
import SafeSiteImage from "./SafeSiteImage";
import styled, { css } from "styled-components";

const ProductCategoryCardStyles = styled(({ className, to, children }) => <Link to={to} className={className}>{children}</Link>)`
  ${({ ...props }) => css`
    display: block;
    background: #fff;
    border-radius: 4px 4px 0 0;
    overflow: hidden;
    position: relative;
    display: flex;

    * {
      width: 100% !important;
    }

    h3 {
      margin-bottom: 8px;
    }

    &:hover {
      background-color: ${props.theme.categoryColor};
      color: #fff;
    }
  `}
`;

const ProductCategoryCardImageStyles = styled.div`
  ${({ ...props }) => css`
    flex-basis: 200px;
    padding: 16px 0 16px 16px;

    img {
      aspect-ratio: 103/77;
      height: auto;
      overflow: hidden;
      border-radius: 4px;
      object-fit: cover;
    }

    @media (min-width: ${props.theme.breakpoints.lg}) {
      flex-basis: 200px;
      padding: 16px;
    }
  `}
`;

const ProductCategoryCardBodyStyles = styled.div`
  ${({ ...props }) => css`
    padding: 16px 16px 24px 16px;
    @media (min-width: ${props.theme.breakpoints.lg}) {
      padding: 24px 24px 32px 8px;
    }
  `}
`;

const BorderStyles = styled.span`
  ${({ ...props }) => css`
    display: block;
    height: 8px;
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: ${props.theme.categoryColor};
  `}
`;

export const ProductCategoryCard = ({
  url,
  title,
  description,
  featuredImage,
}) => {
  return (
    <ProductCategoryCardStyles
      to={url}
      className={'cat-hover'}
    >
      {featuredImage && (
        <ProductCategoryCardImageStyles>
          <SafeSiteImage image={featuredImage} alt={title} width="130" />
        </ProductCategoryCardImageStyles>
      )}
      <ProductCategoryCardBodyStyles>
        <h3>{title}</h3>
        {description && <p>{description}</p>}
        <BorderStyles
          className="cat-bg"
        />
      </ProductCategoryCardBodyStyles>
    </ProductCategoryCardStyles>
  );
};
